import "core-js/modules/es.array.concat";
import React from 'react';
import PropTypes from 'prop-types';
import usePreferredLocale from '@sprinx/react-globalize/usePreferredLocale';
import Loader from '@sprinx/react-loader/Loader';
import { withScriptjs } from 'react-google-maps';
var B = withScriptjs(function (_ref) {
  var children = _ref.children;
  return React.createElement(React.Fragment, null, children);
});
B.displayName = 'GoofleMapInitializatorScripts';
B.propTypes = {
  children: PropTypes.node
};
B.defaultProps = {
  children: null
};

function GoogleMapApiInitializator(_ref2) {
  var children = _ref2.children,
      googleApiKey = _ref2.googleApiKey;
  var lng = usePreferredLocale();
  var Wrapper = googleApiKey ? B : React.Fragment;
  var wrapperProps = googleApiKey ? {
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=".concat(googleApiKey, "&v=3.exp&libraries=geometry,drawing,places&language=").concat(lng),
    loadingElement: React.createElement(Loader, {
      loading: true
    })
  } : {};
  return React.createElement(Wrapper, wrapperProps, children);
}

GoogleMapApiInitializator.propTypes = {
  children: PropTypes.node,
  googleApiKey: PropTypes.string
};
GoogleMapApiInitializator.defaultProps = {
  children: null,
  googleApiKey: undefined
};
export default GoogleMapApiInitializator;